// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var More = function More(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("circle", {
      cx: "1.824",
      cy: "8",
      r: "1.824"
    }),
    /*#__PURE__*/
    React.createElement("circle", {
      cx: "14.176",
      cy: "8",
      r: "1.824"
    }),
    /*#__PURE__*/
    React.createElement("circle", {
      cx: "8",
      cy: "8",
      r: "1.824"
    }))
  );
};

export default More;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/More.js
// module id = 1031
// module chunks = 0